import React from 'react';

const TABS = [
    { key: 'certs', label: 'Certs', hint: 'Inventory to list' },
    { key: 'listings', label: 'Listings', hint: 'Active for sale' },
    { key: 'orders', label: 'Orders', hint: 'Confirm & fulfill' },
];

const BrokerTabs = ({ activeTab, onChange, counts = {} }) => (
    <div className="broker-tabs" role="tablist">
        {TABS.map((t) => (
            <button
                key={t.key}
                role="tab"
                aria-selected={activeTab === t.key}
                className={`broker-tab${activeTab === t.key ? ' active' : ''}`}
                onClick={() => onChange(t.key)}
                title={t.hint}
            >
                <span className="broker-tab-label">{t.label}</span>
                {counts[t.key] !== undefined && (
                    <span className="broker-tab-badge">{counts[t.key]}</span>
                )}
            </button>
        ))}
    </div>
);

export default BrokerTabs;
export { TABS };
